export const serverAddress = '/api/' //Final

export const googleClientId = '448127104593-q9celr92tf75ni47sgbt8nut7c5i2kll.apps.googleusercontent.com'
export const googleClientIdForAdminLogin = '448127104593-q9celr92tf75ni47sgbt8nut7c5i2kll.apps.googleusercontent.com'
export const adminEmailAddress = 'support.ocs@iith.ac.in'
export const adminDomainAddress = undefined
export const reCaptcha_ClientKey = '6LejTbcZAAAAAI5hwB3aHEfEWEq4qfpRxB61-P3I'
